import { render, staticRenderFns } from "./OrderLayoutDialog.vue?vue&type=template&id=129f537a"
import script from "./OrderLayoutDialog.vue?vue&type=script&lang=js"
export * from "./OrderLayoutDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderLayoutDialog.vue?vue&type=style&index=0&id=129f537a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports